module.exports = __webpack_public_path__ + "static/3BHK-03-Kitchen-b3902f78b2a68d4083c6eb1ae0d5e3c1.jpg";